// Cookie choice. The guard in public/index.html reads the same key before any
// other script runs, so anything optional stays switched off until "accepted".
export const CONSENT_KEY = 'cr_cookie_consent';
export const OPEN_CONSENT_EVENT = 'cr-open-consent';

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const openConsentSettings = () => window.dispatchEvent(new Event(OPEN_CONSENT_EVENT));

const heldScripts = () => (window.__crHeldScripts || []).length > 0;
const analyticsRunning = () =>
  Boolean(window.posthog && !window.posthog.__crGuard && typeof window.posthog.opt_out_capturing === 'function');

function clearAnalyticsStorage() {
  [localStorage, sessionStorage].forEach((store) =>
    Object.keys(store).filter((k) => k.startsWith('ph_')).forEach((k) => store.removeItem(k)),
  );
  const host = window.location.hostname;
  const parent = host.split('.').slice(-2).join('.');
  document.cookie
    .split(';')
    .map((c) => c.split('=')[0].trim())
    .filter((name) => name.startsWith('ph_'))
    .forEach((name) => {
      document.cookie = `${name}=; Max-Age=0; path=/`;
      [host, `.${parent}`].forEach((d) => {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${d}`;
      });
    });
}

export function saveConsent(choice) {
  const previous = getConsent();
  localStorage.setItem(CONSENT_KEY, choice);
  if (choice === 'accepted' && heldScripts()) {
    // Reload so the held script starts normally now that it is allowed.
    window.location.reload();
    return;
  }
  if (choice === 'rejected') {
    const wasRunning = analyticsRunning();
    if (wasRunning) window.posthog.opt_out_capturing();
    clearAnalyticsStorage();
    if (previous === 'accepted' && wasRunning) window.location.reload();
  }
}
